import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

const branchOptions = [
  { value: '', label: '-- select branch name --' },
  { value: 'Branch 1', label: 'Branch 1' },
  { value: 'Branch 2', label: 'Branch 2' },
];

const ledgerOptions = [
  { value: '', label: '-- select ledger --' },
  { value: 'Ledger 1', label: 'Ledger 1' },
  { value: 'Ledger 2', label: 'Ledger 2' },
];


const initialRows = [
  {
    sno: 1,
    branchName: 'Branch 1',
    ledgerName: 'Ledger 1',
    transactionDate: '2025-10-09',
    paymentMode: 'Cash',
    creditAmount: 1000,
    debitAmount: 0,
    remarks: 'Sample',
    description: 'Sample description',
  },
  {
    sno: 2,
    branchName: 'Branch 2',
    ledgerName: 'Ledger 2',
    transactionDate: '2025-10-08',
    paymentMode: 'Bank',
    creditAmount: 0,
    debitAmount: 500,
    remarks: 'Test',
    description: 'Test description',
  },
];

function DayBookReport() {
  const [branch, setBranch] = useState('');
  const [ledger, setLedger] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [rows, setRows] = useState(initialRows);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleSearch = () => {
    // Implement search logic here
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(amount);
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Heading Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Day Book Report
        </Typography>
      </Box>

      {/* Search Section */}
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Branch Name</InputLabel>
                  <Select
                    value={branch}
                    label="Branch Name"
                    onChange={e => setBranch(e.target.value)}
                  >
                    {branchOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={2}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Ledger Name</InputLabel>
                  <Select
                    value={ledger}
                    label="Ledger Name"
                    onChange={e => setLedger(e.target.value)}
                  >
                    {ledgerOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSearch}
                  fullWidth
                  sx={{ height: '40px', fontWeight: 600 }}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Details Section */}
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Day Book Entries
        </Typography>
        <Typography variant="body2" color="primary" sx={{ mb: 3, fontWeight: 'bold' }}>
          Total Records: {rows.length}
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Branch Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Ledger Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Transaction Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Payment Mode</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }} align="right">Credit Amount</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }} align="right">Debit Amount</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Remarks</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, idx) => (
                  <TableRow
                    key={row.sno}
                    sx={{
                      '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                      '&:hover': { backgroundColor: '#e3f2fd' }
                    }}
                  >
                    <TableCell>{row.sno}</TableCell>
                    <TableCell>{row.branchName}</TableCell>
                    <TableCell>{row.ledgerName}</TableCell>
                    <TableCell>{row.transactionDate}</TableCell>
                    <TableCell>{row.paymentMode}</TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'success.main' }}>
                        {formatCurrency(row.creditAmount)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'error.main' }}>
                        {formatCurrency(row.debitAmount)}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.remarks}</TableCell>
                    <TableCell>{row.description}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={rows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          sx={{ mt: 2 }}
        />
      </Paper>
    </Box>
  );
}

export default DayBookReport;